/* Empty cart drawer: keeps "Continue shopping" pointing at the page's collection.

   On page load the cart-drawer section is rendered in the page's context, so
   Liquid resolves the current collection (or the product's collection) into
   [data-continue-shopping-url]. Cart changes re-render the section through the
   Section Rendering API outside that context, where it falls back to all
   products. The page-load value is captured once here and put back on the
   button, both after re-renders and at click time as a backstop. */

(function () {
  'use strict';

  var source = document.querySelector('[data-continue-shopping-url]');
  var pageUrl = source ? source.getAttribute('data-continue-shopping-url') : '';
  if (!pageUrl) return;

  function apply() {
    document.querySelectorAll('[data-empty-cart-continue]').forEach(function (link) {
      if (link.getAttribute('href') !== pageUrl) link.setAttribute('href', pageUrl);
    });
  }

  apply();

  document.addEventListener('cart:updated', function () { window.setTimeout(apply, 0); });
  document.addEventListener('cart:refresh', function () { window.setTimeout(apply, 0); });

  // Capture phase, so the href is right before the browser follows the link,
  // whichever re-render path produced the button.
  ['click', 'auxclick'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var link = event.target.closest && event.target.closest('[data-empty-cart-continue]');
      if (link) link.setAttribute('href', pageUrl);
    }, true);
  });
})();
